import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef(({ children, layout = 'default', ...otherProps }, ref) => {
    switch (layout) {
        case 'fullWidth':
            return (React.createElement(S.Container, { ref: ref, ...otherProps }, children));
        case 'default':
        default:
            return (React.createElement(S.Container, { ref: ref, ...otherProps },
                React.createElement(S.Inner, null, children)));
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
